import { HttpStatusCode } from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { CATEGORY_ALIAS } from "../../../types/talk";

import { onLikePost } from "../../../libs/talk";

import { useSandiTalk } from "../../../contexts/boardContext";
import { useUserContext } from "../../../contexts/userContext";

import {
  TalkCategory,
  TalkListItem,
  searchLargeCategory,
  searchMiddleCategory,
} from "../../../services/talkServices";

import StickyHeader from "../../../components/Layout/StickyHeader";
import BoardTab from "../../../components/Talk/BoardTab";
import PostList from "../../../components/Talk/PostList";
import HorizontalRule from "../../../components/Rule/Horizontal";
import { TalkSearchInput } from "../../../components/SearchHeader";

type Props = {};

// eslint-disable-next-line no-empty-pattern
export default function TalkSearch(props: Props) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [talk, { updateCategory }] = useSandiTalk();
  const [searchWord, setSearchWord] = useState(state?.searchQuery ?? "");
  const [postList, setPostList] = useState<TalkListItem[]>([]);
  const [user] = useUserContext();

  useEffect(() => {
    if (talk.middleCategory?.alias === CATEGORY_ALIAS.TALK_ALL) {
      searchLargeCategory({
        category: talk.largeCategory?.alias ?? "",
        searchWord,
        sort: talk?.sort ?? "createdAt.desc",
      }).then((res) => {
        if (res.status === HttpStatusCode.Ok) {
          setPostList(res.data.items);
        }
      });
    } else {
      searchMiddleCategory({
        category: talk.middleCategory?.alias ?? "",
        searchWord,
        sort: talk?.sort ?? "createdAt.desc",
      }).then((res) => {
        if (res.status === HttpStatusCode.Ok) {
          setPostList(res.data.items);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchWord, talk.middleCategory, talk.sort]);

  useEffect(() => {
    updateCategory({
      categoryInfo: {
        largeCategory: talk.largeCategory,
        middleCategory: talk.largeCategory?.lifeCategoryList?.[0],
      },
    });
  }, [talk.largeCategory?.lifeCategoryList]);

  return (
    <div>
      <StickyHeader
        onBackClick={() => navigate("/talk")}
        className="px-4 w-full py-0"
        selectContent={
          <TalkSearchInput
            onClick={setSearchWord}
            className="!bg-white w-full pl-0"
          />
        }
      ></StickyHeader>
      <HorizontalRule margin="0px" className=" border-black border" />
      <div className="pt-5 pb-20">
        <BoardTab
          type="search"
          tabs={
            talk.categoryList?.map(
              (lc: TalkCategory) =>
                ({
                  ...lc,
                  lifeCategoryList:
                    lc.lifeCategoryList?.filter(
                      (item: TalkCategory) => item.name !== "인기글"
                    ) ?? [],
                } as TalkCategory)
            ) ?? []
          }
        />
        <PostList
          postList={postList}
          onClickLike={(postId) =>
            setPostList((prev) =>
              prev.map((post) =>
                post.lifePostId === postId ? onLikePost(post, user) : post
              )
            )
          }
        />
      </div>
    </div>
  );
}
